import React, { PureComponent } from 'react';
import styles from './styles';

const { CloseIcon } = styles;

class ModalIconClose extends PureComponent {
    render() {
        return (
            <CloseIcon />
        );
    }
}

export default ModalIconClose;
